import { SvgIcon, SvgIconProps } from '@mui/material';

export function GroupIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width="24"
        height="12"
        viewBox="0 0 24 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Group">
          <path
            id="Vector"
            d="M12 6.75098C13.63 6.75098 15.07 7.14098 16.24 7.65098C17.32 8.13098 18 9.21098 18 10.381V11.001C18 11.551 17.55 12.001 17 12.001H7C6.45 12.001 6 11.551 6 11.001V10.391C6 9.21098 6.68 8.13098 7.76 7.66098C8.93 7.14098 10.37 6.75098 12 6.75098ZM4 7.00098C5.1 7.00098 6 6.10098 6 5.00098C6 3.90098 5.1 3.00098 4 3.00098C2.9 3.00098 2 3.90098 2 5.00098C2 6.10098 2.9 7.00098 4 7.00098ZM5.13 8.10098C4.76 8.04098 4.39 8.00098 4 8.00098C3.01 8.00098 2.07 8.21098 1.22 8.58098C0.48 8.90098 0 9.62098 0 10.431V11.001C0 11.551 0.45 12.001 1 12.001H4.5V10.391C4.5 9.56098 4.73 8.78098 5.13 8.10098ZM20 7.00098C21.1 7.00098 22 6.10098 22 5.00098C22 3.90098 21.1 3.00098 20 3.00098C18.9 3.00098 18 3.90098 18 5.00098C18 6.10098 18.9 7.00098 20 7.00098ZM24 10.431C24 9.62098 23.52 8.90098 22.78 8.58098C21.93 8.21098 20.99 8.00098 20 8.00098C19.61 8.00098 19.24 8.04098 18.87 8.10098C19.27 8.78098 19.5 9.56098 19.5 10.391V12.001H23C23.55 12.001 24 11.551 24 11.001V10.431ZM12 0.000976562C13.66 0.000976562 15 1.34098 15 3.00098C15 4.66098 13.66 6.00098 12 6.00098C10.34 6.00098 9 4.66098 9 3.00098C9 1.34098 10.34 0.000976562 12 0.000976562Z"
            fill="white"
          />
        </g>
      </svg>
    </SvgIcon>
  );
}
